import React, { useState } from 'react';
import './css/ViralClipsMetadata.css';

const ViralClipsMetadata = ({ clipsData, isEnhanced = false }) => {
  const [expandedClipId, setExpandedClipId] = useState(null);

  // Toggle expanded state for a clip
  const toggleExpand = (clipId) => {
    setExpandedClipId(expandedClipId === clipId ? null : clipId);
  };

  // Extract model or processing information if available
  const modelInfo = clipsData?.model_information || null;
  const processingInfo = clipsData?.processing_metadata || null;

  return (
    <div className="viral-clips-metadata">
      <h2>{isEnhanced ? 'Enhanced' : 'Viral'} Clips Analysis</h2>

      {/* Display model or processing information if available */}
      {(modelInfo || processingInfo) && (
        <div className="model-info">
          <h3>Analysis Information</h3>
          <div className="model-details">
            {modelInfo && (
              <>
                <div className="model-detail">
                  <span className="label">Model:</span>
                  <span className="value">{modelInfo.model_id}</span>
                </div>
                <div className="model-detail">
                  <span className="label">Region:</span>
                  <span className="value">{modelInfo.region}</span>
                </div>
                <div className="model-detail">
                  <span className="label">Processing Time:</span>
                  <span className="value">{modelInfo.processing_time.toFixed(2)}s</span>
                </div>
                <div className="model-detail">
                  <span className="label">Processed At:</span>
                  <span className="value">{new Date(modelInfo.processed_at).toLocaleString()}</span>
                </div>
              </>
            )}
            
            {processingInfo && (
              <>
                {processingInfo.processed_at && (
                  <div className="model-detail">
                    <span className="label">Processed At:</span>
                    <span className="value">{new Date(processingInfo.processed_at).toLocaleString()}</span>
                  </div>
                )}
                {processingInfo.clips_processed && (
                  <div className="model-detail">
                    <span className="label">Clips Processed:</span>
                    <span className="value">{processingInfo.clips_processed}</span>
                  </div>
                )}
                {processingInfo.clips_with_timestamps && (
                  <div className="model-detail">
                    <span className="label">Clips With Timestamps:</span>
                    <span className="value">{processingInfo.clips_with_timestamps}</span>
                  </div>
                )}
              </>
            )}
            
            {isEnhanced && clipsData.enhanced_at && (
              <div className="model-detail">
                <span className="label">Enhanced At:</span>
                <span className="value">{new Date(clipsData.enhanced_at).toLocaleString()}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="clips-container">
        {clipsData?.clips && clipsData.clips.length > 0 ? (
          clipsData.clips.map((clip) => (
            <div 
              key={clip.id} 
              className={`clip-card ${expandedClipId === clip.id ? 'expanded' : ''}`}
              onClick={() => toggleExpand(clip.id)}
            >
              <div className="clip-header">
                <h3>{clip.heading}</h3>
                <div className="viral-score">
                  <span className="score-label">Viral Score:</span>
                  <div className="score-value">{clip.viral_score}/100</div>
                </div>
              </div>
              
              <div className="clip-caption">{clip.small_caption}</div>
              
              <div className="clip-metadata">
                <div className="metadata-section">
                  <h4>Viral Factors:</h4>
                  <ul className="factors-list">
                    {clip.viral_factors.map((factor, index) => (
                      <li key={index} className="factor-item">{factor}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="metadata-section">
                  <h4>Hashtags:</h4>
                  <div className="hashtags-container">
                    {clip.hashtag_categories.map((hashtag, index) => (
                      <span key={index} className="hashtag">{hashtag}</span>
                    ))}
                  </div>
                </div>
              </div>
              
              {expandedClipId === clip.id && (
                <div className="expanded-content">
                  <div className="metadata-section">
                    <h4>Hook Suggestions:</h4>
                    <ul className="suggestions-list">
                      {clip.hook_suggestions.map((suggestion, index) => (
                        <li key={index} className="suggestion-item">{suggestion}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="metadata-section">
                    <h4>Engagement Prompts:</h4>
                    <ul className="prompts-list">
                      {clip.audience_engagement_prompts.map((prompt, index) => (
                        <li key={index} className="prompt-item">{prompt}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="clip-timing">
                    <div className="time-item">
                      <span className="time-label">Start:</span>
                      <span className="time-value">{clip.start_time}</span>
                      {clip.start_seconds !== undefined && (
                        <span className="time-value-seconds">({clip.start_seconds.toFixed(2)}s)</span>
                      )}
                    </div>
                    <div className="time-item">
                      <span className="time-label">End:</span>
                      <span className="time-value">{clip.end_time}</span>
                      {clip.end_seconds !== undefined && (
                        <span className="time-value-seconds">({clip.end_seconds.toFixed(2)}s)</span>
                      )}
                    </div>
                    {clip.duration !== undefined && (
                      <div className="time-item">
                        <span className="time-label">Duration:</span>
                        <span className="time-value">{clip.duration.toFixed(2)}s</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-clips-message">No {isEnhanced ? 'enhanced' : 'viral'} clips metadata available.</div>
        )}
      </div>
    </div>
  );
};

export default ViralClipsMetadata; 